import { render } from "./Highlight.vue?vue&type=template&id=6d4b42c6&scoped=true"
import script from "./Highlight.vue?vue&type=script&lang=js"
export * from "./Highlight.vue?vue&type=script&lang=js"

import "./Highlight.vue?vue&type=style&index=0&id=6d4b42c6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4b42c6"]])

export default __exports__